import React from 'react';
import { FlameIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const perks = ['Instant digital access', 'All 3 bonuses included', 'One-time payment', 'Never a subscription'];
export function FinalCta() {
  return <section className="w-full bg-ink py-20 text-white sm:py-28" data-id="element-52" data-mp="19cupk7wo72qt">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-53" data-mp="15ckjywcsiech">
        <p className="mb-5 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.18em] text-sunshine" data-id="element-54" data-mp="1jclja7depdpu">
          <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-55" data-mp="1ed0n24pmfjgt" />
          Last chance — limited offer
        </p>
        <h2 className="font-display text-3xl font-black leading-tight sm:text-4xl md:text-5xl" data-id="element-56" data-mp="1t1n1m47fc76z">
          Your kids deserve to build something real
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-white/70" data-id="element-57" data-mp="22339a46utv7i">
          Give them 100+ robot projects, 3 free bonuses, and hours of screen-free
          fun — all for one simple payment.
        </p>
        <div className="mt-10" data-id="element-58" data-mp="n6nsn2tp2cyw">
          <CtaButton data-id="element-59" data-mp="n7fhlussdcg7">Yes! I want MakerLab now</CtaButton>
        </div>
        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-white/70" data-id="element-60" data-mp="s5qr24f65kxw">
          {perks.map(p => <li key={p} className="flex items-center gap-1.5" data-id="element-61" data-mp="x64wrftasisr">
              <CheckIcon className="h-4 w-4 text-sunshine" aria-hidden="true" data-id="element-62" data-mp="123n10swde9uf" />
              {p}
            </li>)}
        </ul>
      </div>
    </section>;
}